import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "euler-dao",
    {
      name: "Euler DAO",
      logo: "entities/euler.svg",
      description:
        "The Euler DAO is the organisation responsible for the creation of the Euler lending/borrowing platform.",
      url: "https://euler.finance/",
      addresses: {
        "0x89Ad331C4B69d7b251C9937DD9A9CEA6E357997a": "Euler DAO Multisig",
        "0x703AB67Cd644165503551Dfbf90727D3Bc47887D":
          "Euler Vault Access Control Governor",
      },
      social: {
        twitter: "eulerfinance",
        youtube: "EulerFinance",
        discord: "https://discord.euler.finance/",
        telegram: "eulerfinance_official",
        github: "euler-xyz",
      },
    },
  ],
  [
    "gauntlet",
    {
      name: "Gauntlet",
      logo: "entities/gauntlet.svg",
      description:
        "Gauntlet's applied research and optimization teams model market risk, economic incentives, and drive sustainable growth for crypto's top protocols, chains, and onchain treasuries.",
      url: "https://www.gauntlet.xyz/",
      addresses: {
        "0x703AB67Cd644165503551Dfbf90727D3Bc47887D":
          "Euler Vault Access Control Governor",
      },
      social: { twitter: "gauntlet_xyz" },
    },
  ],
  [
    "zerolend",
    {
      name: "ZeroLend",
      logo: "entities/zerolend.jpg",
      description:
        "ZeroLend is a decentralized lending market curating vaults for LRTs, Real World Assets (RWAs), BTCFi, and promising tokens.",
      url: "https://zerolend.xyz/",
      addresses: {
        "0x54061E18cd88D2de9af3D3D7FDF05472253B29E0": "ZeroLend Governor",
      },
      social: { twitter: "zerolendxyz" },
    },
  ],
  [
    "re7-labs",
    {
      name: "Re7 Labs",
      logo: "entities/re7labs.png",
      description:
        "Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.",
      url: "https://www.re7labs.xyz/",
      addresses: {
        "0xddedB1F2d1dd0b0455Fe5277632c84f57f894011": "Re7 Labs Euler Multisig",
      },
      social: { twitter: "Re7Labs" },
    },
  ],
  [
    "edge-capital",
    {
      name: "Edge UltraYield",
      logo: "entities/edge.png",
      description:
        "Edge Capital is a leading market-neutral hedge fund that manages capital for largest fund of funds, institutional investors and leading crypto foundations and treasuries since 2020",
      url: "https://edgecapital.xyz/",
      addresses: {
        "0x1280e86Cd7787FfA55d37759C0342F8CD3c7594a": "Edge Capital Multisig",
      },
      social: { twitter: "EdgeCapitalMgmt" },
    },
  ],
  [
    "tulipa-capital",
    {
      name: "Tulipa Capital",
      logo: "entities/tulipacapital.png",
      description:
        "At Tulipa Capital, we leverage cutting-edge technology and innovative financial strategies to maximize yields while implementing rigorous risk management practices.",
      url: "https://www.tulipa.capital/",
      addresses: {
        "0xF53eAeB7e6f15CBb6dB990eaf2A26702e1D986d8": "Tulipa Capital Multisig",
      },
      social: { twitter: "tulipacapital" },
    },
  ],
  [
    "mev-capital",
    {
      name: "MEV Capital",
      logo: "entities/mev-capital.svg",
      description:
        "MEV Capital is a digital asset manager that focuses on finding and extracting value from the nascent DeFi markets. The strategies are conducted following a stable asset exposure mandate supported by well-defined benchmarks. The operations mainly consist of risk curations and liquidity provisioning to a set of public protocols. These protocols are selected to reflect internal risk management rules, fit regulatory criteria, and answer investor needs. MEV Capital aims to achieve consistent returns for the investors, while operating in a highly liquid environment and battle-tested security framework.",
      url: "https://mevcapital.com/",
      addresses: {
        "0xB672Ea44A1EC692A9Baf851dC90a1Ee3DB25F1C4": "MEV Capital Multisig",
      },
      social: { twitter: "mevcapital" },
    },
  ],
])
